import { CountryCode } from '../enums/country-code.enum'

export interface ICountry {
  id: string
  abbreviation: string
  name: string
  countryCode: CountryCode
}
